/** @jsxImportSource @emotion/react */

import { Typography } from '@mui/material'
import { useMemo, useState } from 'react'
import { createSearchParams, useLocation, useParams, useSearchParams } from 'react-router-dom'
import TabsNavigation from 'components/TabsNavigation/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import { RouteValue, useLink } from 'routes/cmsRoutes'
import { PlatformSlug } from 'constants/consts'
import NotFound from 'components/NotFound'
import * as classes from './styles'
import { SuccessStories } from './SuccessStories'
import { StudyGuide } from './StudyGuide'
import { SUCCESS_STORIES_TAB, STUDY_GUIDE_TAB, TABS, QUERY_PARAM } from './consts'
import { getBlogPagesConfig, isBlogPagesAvailable } from './platformConfig'

export { SUCCESS_STORIES_TAB, STUDY_GUIDE_TAB, QUERY_PARAM }

export const BlogPages = () => {
  const location = useLocation()
  const { navigate } = useLink()
  const [searchParams] = useSearchParams()
  const { platform } = useParams()

  const blogConfig = getBlogPagesConfig(platform as PlatformSlug)
  const tabs = useMemo(
    () =>
      TABS.filter((tab) => {
        if (tab.id === SUCCESS_STORIES_TAB.id) {
          return blogConfig?.successStories
        }
        if (tab.id === STUDY_GUIDE_TAB.id) {
          return blogConfig?.studyGuides
        }
        return false
      }),
    [blogConfig]
  )
  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(QUERY_PARAM)

    return tabs.find(({ id }) => id === tabId) || tabs[0]
  })

  const handleChangeTab = (activeTab: TabsItem) => {
    navigate(location.pathname as RouteValue, undefined, {
      searchParams: createSearchParams({ [QUERY_PARAM]: activeTab.id }),
    })
    setActiveTab(activeTab)
  }

  const renderTab = () => {
    if (activeTab.id === SUCCESS_STORIES_TAB.id) {
      return <SuccessStories />
    }

    if (activeTab.id === STUDY_GUIDE_TAB.id) {
      return <StudyGuide />
    }

    return null
  }

  if (!isBlogPagesAvailable(platform as PlatformSlug) || !tabs.length) {
    return <NotFound />
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Blog Pages
      </Typography>

      <TabsNavigation css={classes.tabs} tabs={tabs} value={activeTab} onChange={handleChangeTab} />

      {renderTab()}
    </section>
  )
}
